import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import type { AutoBidNotOrderedNotice } from '@ebalance/proto/bffuser/v1/auto_bid_notice_model_pb'
import {
  GlobalAlertService,
  ListAutoBidNotOrderedNoticesRequestSchema,
} from '@ebalance/proto/bffuser/v1/global_alert_service_pb'

import {
  SIDE_MENU_DOT_QUERY_OPTIONS,
  freshSideMenuDotData,
} from '~/hooks/sideMenuDotQuery'

/**
 * 自動入札が発注しなかったコマの記録 (表示期間内で未解消のもの。AC-APF-069)。
 * サイドメニューのドット (AC-SC-041) 用に layout の `SideMenuDotsProvider` が 1 か所で呼ぶ
 * (observer を増やすと `refetchInterval` が observer ごとに走り、30 秒に複数回取得する)。
 * layout の内側の画面 (入札画面の警告バナー等) は `useLayoutAutoBidNotOrderedNotices` で
 * その結果を読む。組織は BFF が認証セッションから決める。
 *
 * 取得方針 (30 秒の再取得・失敗時は直前の data を捨てる等) は `sideMenuDotQuery` が持つ。
 * 取得中・取得失敗・オフラインで保留の間は空配列。
 */
export function useAutoBidNotOrderedNotices(): {
  notices: readonly AutoBidNotOrderedNotice[]
} {
  const query = useQuery(
    GlobalAlertService.method.listAutoBidNotOrderedNotices,
    create(ListAutoBidNotOrderedNoticesRequestSchema, {}),
    SIDE_MENU_DOT_QUERY_OPTIONS,
  )
  const data = freshSideMenuDotData(query)
  if (data === undefined) return { notices: [] }
  return { notices: data.notices }
}
